export enum QuietHoursPolicy {
  OFF = "OFF",
  WARN = "WARN",
  BLOCK = "BLOCK",
}
